import {
	Form, Modal, Select, Input, Spin, Button
}from "antd"
import React, {
	useEffect, useState
}from "react"
import {
	useDispatch, useSelector
}from "react-redux"
import CustomButton from "../../../components/CustomButton"
import CustomInput from "../../../components/CustomInput"
import CustomSelect from "../../../components/CustomSelect"
import CustomUpload from "../../../components/CustomUpload"
import Notifications from "../../../helpers/Notifications"
import {
	messageToAdminActions
}from "../../MessageToAdmin/store/actions"
import {
	reMessageToAdminTypesActions
}from "../../NRI/ReMessageToAdminTypes/store/actions"
import HelpTagCard from "../HelpTagCard"
import ModalCreateHelp from "../ModalCreateHelp"
import {
	helpSectionActions
}from "../store/actions"
import PlusIcon from "../../../components/Icons/plus.svg"
import './style.css'
import {
	SearchOutlined
}from "@ant-design/icons"
import {
	useDebounce
}from "use-debounce"
import LocalLoading from "../../../components/Loading/Local"
import CustomEditor from "../../../components/CustomEditor"

const HelpList = ({ isModify, withHeader = true }) => {
	const { user } = useSelector((state) => state.userReducer)
	const { helpTags, tagChanged, isSending } = useSelector((state) => state.helpSectionReducer)
	const dispatch = useDispatch()
	const [form] = Form.useForm()
	const [visible, setVisible] = useState(false)
	const [isVisibleModalCreateHelp, setIsVisibleModalCreateHelp] = useState(false)
	const [search, setSearch] = useState(null)
	const [isCreateNewTag, setIsCreateNewTag] = useState(false)
	const [changeableHelp, setChangeableHelp] = useState(null)
	const [helpTag, setHelpTag] = useState(null)
	const { list } = useSelector(state => state.reMessageToAdminTypeReducer)
	const { isMessageSending, isSend } = useSelector(state => state.messageToAdminReducer)
	const [searchHelp] = useDebounce(search, 500)

	const getList = () => {
		dispatch(reMessageToAdminTypesActions.getList({ pageSize: 100 }))
	}

	const getHelpTags = (values) => {
		dispatch(helpSectionActions.getHelpTags(values))
	}

	const getActualHelpTags = (values) => {
		dispatch(helpSectionActions.getActualHelpTags(values))
	}

	const createHelp = (values) => {
		dispatch(helpSectionActions.createHelp(values))
	}

	const updateHelp = (values) => {
		dispatch(helpSectionActions.updateHelp(values))
	}

	useEffect(() => {
		isModify
			? getHelpTags({
				name: searchHelp
			})
			: getActualHelpTags({
				name: searchHelp
			})
	}, [searchHelp])

	useEffect(() => {
		if (tagChanged){
			Notifications.successNotice(tagChanged)
			isModify
				? getHelpTags({
					name: searchHelp
				})
				: getActualHelpTags({
					name: searchHelp
				})
		}
	}, [tagChanged])

	const headSection = () => {
		return (
			<div className="head-section">
				<CustomInput
					allowClear
					className="search-box"
					maxLength={ 255 }
					placeholder="Поиск статьи"
					prefix={ <SearchOutlined /> }
					value={ search }
					onChange={ (e) => setSearch(e.target.value) }
				/>
				{ Boolean(!user?.roles?.includes("mainAdmin") && !user?.roles?.includes("priceMonitoringMainOperator")) && (
					<CustomButton
						htmlType="submit"
						onClick={ () => setVisible(!visible) }
					>
						Задать вопрос администратору
					</CustomButton>
				) }
			</div>
		)
	}

	const sendMesssageToAdmin = (values) => {
		values.message = values.message?.trim()
		values.name = values.name?.trim()
		values.email = values.email?.trim()
		if (user){
			const formData = new FormData()
			values.files?.forEach((src) => {
				formData.append("Files", src.originFileObj)
			})
			formData.append("Message", values.message ?? "")
			formData.append("Name", values.name)
			formData.append("Email", values.email ?? "")
			dispatch(messageToAdminActions.createOrg(formData))
		}
		else
			dispatch(messageToAdminActions.create(values))
	}

	const addNewTag = () => {
		setIsCreateNewTag(true)
	}

	function handleCancel(){
		setVisible(false)
	}

	useEffect(() => {
		getList()
		return () => {
			dispatch(messageToAdminActions.clear())
			dispatch(helpSectionActions.clear())
		}
	}, [])

	useEffect(() => {
		if (isSend){
			Notifications.successNotice("Сообщение успешно отправлено администратору.")
			form.resetFields()
			handleCancel()
		}
	}, [isSend])

	const normFile = (e) => {
		if (Array.isArray(e))
		  return e
		return e?.fileList
	}

	return (
		<div className="help-container">
			<div className="help-wrapper">
				{ (isModify || !withHeader) ||
				<h2 className="help-title">
					Помощь
				</h2> }
				{ headSection() }
				<Spin
					indicator={ <LocalLoading /> }
					spinning={ isSending }
				>
					<div className="body-help-section">
						{ helpTags.map((elem) => (
							<HelpTagCard
								key={ elem.id }
								isModify={ isModify }
								setChangeableHelp={ setChangeableHelp }
								setHelpTag={ setHelpTag }
								setIsCreateNewTag={ setIsCreateNewTag }
								setIsVisibleModalCreateHelp={ setIsVisibleModalCreateHelp }
								tag={ elem }
							/>)) }
						{
							Boolean(isCreateNewTag) &&
								<HelpTagCard
									isEmptyTag
									isCreateNewTag={ isCreateNewTag }
									isModify={ isModify }
									setHelpTag={ setHelpTag }
									setIsCreateNewTag={ setIsCreateNewTag }
									setIsVisibleModalCreateHelp={ setIsVisibleModalCreateHelp }
									tag={ null }
								/>
						}
						{ Boolean(isModify) &&
							<div
								className="help-tag-card-add"
								onClick={ addNewTag }
							>
								<div className="help-tag-add-plus">
									<img src={ PlusIcon } />
								</div>
							</div> }
					</div>
				</Spin>
			</div>
			<Modal
				footer={ null }
				title="Задать вопрос администратору"
				visible={ visible }
				width={ 950 }
				onCancel={ handleCancel }
			>
				<Form
					form={ form }
					onFinish={ (values) => {
						sendMesssageToAdmin(values)
					} }
				>
					<Form.Item
						name="type"
					>
						<CustomSelect
							allowClear
							placeholder="Выберите тип сообщения"
							style={ {
								width: "100%"
							} }
						>
							{ list?.map((elem) => {
								return (
									<Select.Option
										key={ elem.id }
										title={ elem.name }
										value={ elem.id }
									>
										{ elem.name }
									</Select.Option>
								)
							}) }
						</CustomSelect>
					</Form.Item>
					<Form.Item
						name="name"
						rules={ [
							{
								required : true,
								message  : "Пожалуйста, введите имя."
							},
							{
								min     : 2,
								max     : 100,
								message : "Длина строки 2-100 символов"
							}
						] }
						style={ { textOverflow: "ellipsis" } }
					>
						<CustomInput
							maxLength={ 100 }
							placeholder="Введите ваше имя"
							type="text"
						/>
					</Form.Item>
					<Form.Item
						name="email"
						rules={ [
							{
								required : !user?.reOrg,
								pattern  : /^[-\w.]+@([A-z0-9][-A-z0-9]+\.)+[A-z]{2,4}$/,
								min      : !user?.reOrg ? 2 : 0,
								max      : 500,
								message  : "Проверьте корректность введенных данных. Убедитесь, что адрес электронной почты указан в таком формате: example@mail.com"
							}
						] }
					>
						<CustomInput
							maxLength={ 400 }
							placeholder="Введите ваш е-mail"
						/>
					</Form.Item>
					<Form.Item
						name="message"
						rules={ [
							{
								required   : true,
								whitespace : true,
								message    : "Пожалуйста, введите текст вопроса."
							}
						] }
					>
						<Input.TextArea
							autoSize={ {
								minRows : 3,
								maxRows : 7
							} }
							placeholder="Введите ваш вопрос"
						/>
					</Form.Item>
					{ Boolean(user) &&
						<Form.Item
							getValueFromEvent={ normFile }
							name="files"
							valuePropName="fileList"
						>
							<CustomUpload multiple />
						</Form.Item> }
					<Form.Item>
						<CustomButton
							htmlType="submit"
							loading={ isMessageSending }
							style={ {
								width: "100%"
							} }
						>
              Задать вопрос
						</CustomButton>
					</Form.Item>
				</Form>
			</Modal>
			<ModalCreateHelp
				changeableHelp={ changeableHelp }
				createHelp={ createHelp }
				helpTag={ helpTag }
				helpTags={ helpTags }
				isVisibleModalCreateHelp={ isVisibleModalCreateHelp }
				setChangeableHelp={ setChangeableHelp }
				setHelpTag={ setHelpTag }
				setIsVisibleModalCreateHelp={ setIsVisibleModalCreateHelp }
				updateHelp={ updateHelp }
			/>
		</div>
	)
}

export default HelpList